module.exports = __webpack_public_path__ + "img/banner1.0a2b4483.png";